import { IconProps } from './index';

interface CheckboxCircleFillProps extends IconProps {
    className?: string;
    checked?: boolean;
    handleClick?: () => void;
}

const CheckboxCircleFill: React.FC<CheckboxCircleFillProps> = ({
    className = '',
    checked = false,
    handleClick,
    title,
    titleId,
}) => {
    return (
        <svg
            className={className}
            onClick={handleClick}
            width="1.2em"
            height="1.2em"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
        >
            {title && <title id={titleId}>{title}</title>}
            {!checked ? (
                <path d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z" />
            ) : (
                <path d="M10 20C4.477 20 0 15.523 0 10C0 4.477 4.477 0 10 0C15.523 0 20 4.477 20 10C20 15.523 15.523 20 10 20ZM9.003 14L16.073 6.929L14.659 5.515L9.003 11.172L6.174 8.343L4.76 9.757L9.003 14Z" />
            )}
        </svg>
    );
};
export default CheckboxCircleFill;
